__turbopack_context__.v({
  "bulletsContainer": "ReviewSectionMbaLp-module-scss-module__3xi8fq__bulletsContainer",
  "closeButton": "ReviewSectionMbaLp-module-scss-module__3xi8fq__closeButton",
  "closeButtonContainer": "ReviewSectionMbaLp-module-scss-module__3xi8fq__closeButtonContainer",
  "cus_btn": "ReviewSectionMbaLp-module-scss-module__3xi8fq__cus_btn",
  "enquireNowBtn": "ReviewSectionMbaLp-module-scss-module__3xi8fq__enquireNowBtn",
  "header_container": "ReviewSectionMbaLp-module-scss-module__3xi8fq__header_container",
  "iframeContainer": "ReviewSectionMbaLp-module-scss-module__3xi8fq__iframeContainer",
  "nextArrow": "ReviewSectionMbaLp-module-scss-module__3xi8fq__nextArrow",
  "prevArrow": "ReviewSectionMbaLp-module-scss-module__3xi8fq__prevArrow",
  "readMoreBtn": "ReviewSectionMbaLp-module-scss-module__3xi8fq__readMoreBtn",
  "reviewBody": "ReviewSectionMbaLp-module-scss-module__3xi8fq__reviewBody",
  "reviewContent": "ReviewSectionMbaLp-module-scss-module__3xi8fq__reviewContent",
  "reviewText": "ReviewSectionMbaLp-module-scss-module__3xi8fq__reviewText",
  "reviewerDegree": "ReviewSectionMbaLp-module-scss-module__3xi8fq__reviewerDegree",
  "reviewerDetails": "ReviewSectionMbaLp-module-scss-module__3xi8fq__reviewerDetails",
  "reviewerImg": "ReviewSectionMbaLp-module-scss-module__3xi8fq__reviewerImg",
  "reviewerName": "ReviewSectionMbaLp-module-scss-module__3xi8fq__reviewerName",
  "reviewsCarouselWrapper": "ReviewSectionMbaLp-module-scss-module__3xi8fq__reviewsCarouselWrapper",
  "reviewsMbaContainer": "ReviewSectionMbaLp-module-scss-module__3xi8fq__reviewsMbaContainer",
  "reviewsOnlineContainer": "ReviewSectionMbaLp-module-scss-module__3xi8fq__reviewsOnlineContainer",
  "reviewsOnlineDesc": "ReviewSectionMbaLp-module-scss-module__3xi8fq__reviewsOnlineDesc",
  "reviewsOnlineItem": "ReviewSectionMbaLp-module-scss-module__3xi8fq__reviewsOnlineItem",
  "reviewsOnlineTitle": "ReviewSectionMbaLp-module-scss-module__3xi8fq__reviewsOnlineTitle",
  "slideWrapper": "ReviewSectionMbaLp-module-scss-module__3xi8fq__slideWrapper",
  "stars": "ReviewSectionMbaLp-module-scss-module__3xi8fq__stars",
  "textReviewContainer": "ReviewSectionMbaLp-module-scss-module__3xi8fq__textReviewContainer",
  "text_caru_container": "ReviewSectionMbaLp-module-scss-module__3xi8fq__text_caru_container",
  "videoModalBox": "ReviewSectionMbaLp-module-scss-module__3xi8fq__videoModalBox",
  "videoModalContainer": "ReviewSectionMbaLp-module-scss-module__3xi8fq__videoModalContainer",
  "videoModalContent": "ReviewSectionMbaLp-module-scss-module__3xi8fq__videoModalContent",
});
